export default __webpack_public_path__ + "static/media/bd1f7375a191a30420b835ba27888398.svg";